export default function scrollerSponsorsDouble(widgetElName, widgetElOpts, sponsorsTime) {
  const widgetName = widgetElName;
  const widgetOpts = widgetElOpts;
  const $widget = $(`#${widgetName}`);

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      setTimeout(() => {
        if (widgetElName === 'scroller-sponsors-second') {
          updateSecondSponsorsStructure();
        } else {
          updateFirstSponsorsStructure();
        }

        const pauseBtn = $(`#${widgetElName} .sponsor-controls-container button`);
        pauseBtn.replaceWith('<span class="sponsor-playpause-btn"></span>');
        $(`#${widgetElName} .sponsor-playpause-btn`).on('click', function () {
          $(`#${widgetElName} .sponsorWidgetContainer `).toggleClass('sponsors-paused');
        });
      }, 2000);

      clearInterval(interval);
    }
  }, 1000);

  function updateSecondSponsorsStructure() {
    $(`#${widgetElName} .sponsorWidgetContainer`).appendTo('.second-scroller-container');
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('second-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo('.second-scroller-container');
    $(`#${widgetElName} #sponsorArrowRight`).appendTo('.second-scroller-container');
  }

  function updateFirstSponsorsStructure() {
    const $majorSponsorTitle = $(`#${widgetElName} #majorSponsorTitleContainer`);
    const $majorSponsorContainer = $(`#${widgetElName} .majorSponsor`);
    const majorSponsorsTitle = $('#majorSponsorTitleContainer .homepageh1').text();

    if ($majorSponsorContainer.length && $majorSponsorTitle.length) {
      $majorSponsorTitle.wrapAll('<div class="major-sponsor-wrapper" id="major-sponsor-wrapper">');
      $majorSponsorContainer.appendTo($('#major-sponsor-wrapper'));
      $('#major-sponsor-wrapper').prependTo($(`#${widgetElName}`));

      $('#majorSponsorTitleContainer .homepageh1').replaceWith(
        `<h2 class="major-sponsor-title">${majorSponsorsTitle}</h2>`,
      );
    }

    const sponsorsTitleContent = $('#sponsorsTitleContainer .homepageh1').text();
    $('#sponsorsTitleContainer .homepageh1').replaceWith(
      `<h2 class="main-sponsors-title">${sponsorsTitleContent}</h2>`,
    );

    $(`#${widgetElName} .sponsorWidgetContainer `).appendTo('.scroller-container');
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('default-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo('.scroller-container');
    $(`#${widgetElName} #sponsorArrowRight`).appendTo('.scroller-container');
  }

  return saffire.widgets.sponsors($($widget), {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: sponsorsTime,
    bw: false,
    rotate: true,
  });
}
